import Bugsnag from "@bugsnag/js";
import classNames from "classnames";
import { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import Tag from "@Components/atoms/Tag";
import { ReactComponent as IconFrownHead } from "@Icons/16x16/frown-head.svg";
import { Tile } from "@Types/pagify";
import { getLabelIcon, getLink } from "@Utils/pagify";
import "./style.scss";

export const LargeProductCardsItem: FunctionComponent<{
  tile: Tile;
}> = ({ tile }) => {
  const intl = useIntl();
  const localeSlug = intl.locale;

  const title = !!tile.textBlock1 && tile.textBlock1[0].text;
  const priceText = !!tile.textBlock2 && tile.textBlock2[0].text;
  const priceValue = !!tile.textBlock3 && tile.textBlock3[0].text;

  const tileImage = tile.images.length > 0 && tile.images[0].desktop;
  const label = tile.label?.text ? tile.label : null;

  const isOutOfStock = tile.metadata?.products
    ? !tile.metadata.products.some((product) => product.availability === "normal")
    : false;

  const LabelIcon = tile.label ? getLabelIcon(tile.label.labelType) : null;

  if (!title) {
    Bugsnag.notify(new Error(`title for tile ${tile.slug} not found in LargeProductCardsItem`));
  } else if (!tileImage) {
    Bugsnag.notify(new Error(`image for tile ${tile.slug} not found in LargeProductCardsItem`));
  }

  return (
    <a
      className="LargeProductCardsItem"
      href={getLink(tile.navigationLink, localeSlug)}
      key={tile.slug}
    >
      {!!tileImage && (
        <img
          alt={`${title ? title : ""} Cheerz`}
          className={classNames("LargeProductCardsItem-image", {
            "LargeProductCardsItem-image--outOfStock": isOutOfStock,
          })}
          src={tileImage["1x"]}
          srcSet={`${tileImage["1x"]} 1x, ${tileImage["2x"]} 2x`}
        />
      )}
      {!!label && (
        <div className="LargeProductCardsItem-label">
          <Tag backgroundColor={label.color.hex} size="m">
            {LabelIcon && <LabelIcon />}
            {label.text}
          </Tag>
        </div>
      )}
      {isOutOfStock && (
        <div className="LargeProductCardsItem-label--outOfStock">
          <Tag backgroundColor="#fa4364" isRotated={true} size="m">
            <IconFrownHead />
            {intl.formatMessage({ id: "cheerz_Drafts_out_of_stock" })}
          </Tag>
        </div>
      )}
      <div className="LargeProductCardsItem-infos">
        <div className="LargeProductCardsItem-infos-top">
          <h2 className="LargeProductCardsItem-title">{title}</h2>
          <div className="LargeProductCardsItem-price">
            {priceText && <div className="LargeProductCardsItem-price-text">{priceText}</div>}
            <div className="LargeProductCardsItem-price-value">{priceValue}</div>
          </div>
        </div>
        {!!tile.textBlock4 &&
          tile.textBlock4.slice(0, 4).map((textBlock) => {
            return (
              <ul
                className="LargeProductCardsItem-description"
                dangerouslySetInnerHTML={{ __html: textBlock.text }}
                key={textBlock.text}
              ></ul>
            );
          })}
      </div>
    </a>
  );
};
